<template>
  <div class="page flex-col">
    <div class="main-container">
      <!-- 模糊背景层 -->
      <!-- <div class="backdrop-layer"></div> -->

      <!-- 左侧边栏 -->
      <div class="sidebar">
        <div class="filter-section">
          <!-- 原有内容保持不变 -->
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
            "
          >
            <img
              style="
                width: 46px;
                height: 46px;
                flex-shrink: 0;
                aspect-ratio: 13/11;
              "
              src="./assets/img/chat.png"
              alt=""
            />
            <span class="rcktext">消息</span>
          </div>

          <div style="margin-top: 20px" class="filter-title">筛选条件</div>

          <div class="filter-group">
            <div class="group-title">消息状态</div>
            <div class="checkbox-group">
              <label
                class="checkbox-item"
                v-for="status in messageStatusOptions"
                :key="status.value"
              >
                <input
                  type="radio"
                  name="messageStatus"
                  :value="status.value"
                  v-model="selectedMessageStatus"
                  @click="handleRadioClick('messageStatus', status.value)"
                />
                <span>{{ status.label }}</span>
              </label>
            </div>
          </div>

          <!-- 岗位名称筛选器 -->
          <div class="filter-group">
            <div class="group-title">岗位名称</div>
            <div class="checkbox-group">
              <label
                class="checkbox-item"
                v-for="category in categories"
                :key="category.id"
              >
                <input
                  type="radio"
                  name="jobCategory"
                  :value="category.id"
                  v-model="selectedJobCategory"
                  @click="handleRadioClick('jobCategory', category.id)"
                />
                <span
                  class="category-name-tooltip"
                  :title="category.name"
                  :data-full-text="category.name"
                >
                  {{ truncateText(category.name, 5) }}
                </span>
              </label>
            </div>
          </div>

          <!-- 对话时间筛选器 -->
          <div class="filter-group">
            <div class="group-title">对话时间</div>
            <div class="checkbox-group">
              <label
                class="checkbox-item"
                v-for="timeRange in timeRangeOptions"
                :key="timeRange.value"
              >
                <input
                  type="radio"
                  name="timeRange"
                  :value="timeRange.value"
                  v-model="selectedTimeRange"
                  @click="handleRadioClick('timeRange', timeRange.value)"
                />
                <span>{{ timeRange.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="content-body">
        <div class="chat-container">
          <!-- 左侧聊天列表面板 -->
          <div class="left-panel">
            <!-- 标签栏 -->
            <div class="tab-bar">
              <div
                class="tab-item"
                :class="{ active: currentTab === 'all' }"
                @click="switchTab('all')"
              >
                全部
              </div>
              <div
                class="tab-item"
                :class="{ active: currentTab === 'favorite' }"
                @click="switchTab('favorite')"
              >
                我的收藏
              </div>
              <!-- <div class="tab-item" 
                   :class="{ active: currentTab === 'locked' }" 
                   @click="switchTab('locked')">已锁定</div> -->
            </div>

            <!-- <div class="search-bar">
              <input type="text" class="search-input" placeholder="搜索岗位" v-model="search_query"
                @keyup.enter="handle_search">
              <div class="search-icon-container" @click="handle_search">
                <div class="search-icon">
                  <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
                </div>
              </div>
            </div> -->

            <!-- 聊天会话列表 -->
            <div class="chat-list">
              <div
                v-for="session in chat_sessions"
                :key="session.id"
                class="chat-item"
                :class="{ active: current_session_id === session.id }"
                @click="select_session(session)"
              >
                <span
                  v-if="session.business_unread_count > 0"
                  class="unread-dot"
                ></span>
                <!-- 头像 -->
                <div class="avatar-container">
                  <Avatar
                    :src="$getAvatarUrl(session) || default_avatar"
                    :char="session.user_name"
                    :size="68"
                  />
                  <!-- 未读红点 -->
                </div>

                <!-- 聊天信息 -->
                <div class="chat-info">
                  <span class="name">{{ session.user_name || "未命名" }}</span>
                  <span class="position-tag">{{ session.title }}</span>
                  <div class="message-section">
                    <span class="last-message">
                      <template v-if="session.last_message_type === 4">
                        <img
                          src="./assets/img/link.png"
                          alt="面试记录"
                          class="interview-record-icon"
                          style="
                            width: 16px;
                            height: 16px;
                            vertical-align: middle;
                            margin-right: 4px;
                          "
                        />
                        <span>面试记录</span>
                      </template>
                      <template v-else>
                        {{ session.last_message_content || "暂无消息" }}
                      </template>
                    </span>
                    <span class="timestamp">{{
                      session.last_message_time
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧聊天内容面板 -->
          <div class="right-panel">
            <!-- 聊天头部（当前聊天对象信息） -->
            <div class="chat-header" v-if="current_session">
              <!-- 左侧用户信息 -->
              <div class="user-info">
                <div class="user-name">
                  {{
                    current_session.user_name ||
                    current_session.title ||
                    "未命名"
                  }}
                </div>
                <div class="company-tag" v-if="current_session.company_name">
                  {{ current_session.company_name }}
                </div>
                <div class="typing-status" v-if="typing_status">
                  {{ typing_status }}
                </div>
              </div>

              <!-- 右侧操作按钮 -->
              <div class="action-buttons">
                <button
                  class="action-btn pin-btn"
                  :class="{
                    active: current_session && current_session.is_pinned == 1,
                  }"
                  @click="togglePin"
                >
                  <img src="./assets/img/top.svg" alt="pin" />
                  <span>置顶</span>
                </button>
                <button
                  class="action-btn"
                  :class="{
                    active: current_session && current_session.is_muted == 1,
                  }"
                  @click="toggleMute"
                >
                  <img src="./assets/img/nobother.svg" alt="nobother" />
                  <span>免打扰</span>
                </button>
                <!-- <button class="action-btn" @click="deleteChat">
                  <img src="./assets/img/delete.svg" alt="delete" />
                  <span>删除</span>
                </button> -->
              </div>
            </div>

            <!-- 聊天消息区域 -->
            <div class="chat-content" v-if="current_session">
              <!-- 消息列表 -->
              <div v-for="(msg, index) in messages" :key="msg.id">
                <!-- 日期分割线 - 只在每条消息前显示，如果日期发生变化 -->
                <div
                  v-if="shouldShowDateDivider(msg, index)"
                  class="date-divider"
                >
                  {{ formatMessageDate(msg.create_time) }}
                </div>

                <div
                  class="message-item"
                  :class="{
                    mine: is_own_message(msg),
                    other: !is_own_message(msg),
                  }"
                >
                  <!-- 对方头像（仅对方消息显示） -->
                  <img
                    v-if="!is_own_message(msg)"
                    :src="msg.sender_avatar"
                    alt="对方头像"
                    class="avatar other-avatar"
                  />

                  <!-- 自己头像（仅自己消息显示） -->
                  <img
                    v-if="is_own_message(msg)"
                    :src="msg.sender_avatar"
                    alt="自己头像"
                    class="avatar my-avatar"
                  />

                  <div class="message-bubble">
                    <!-- 文本消息 -->
                    <p class="message-text" v-if="msg.message_type === 1">
                      {{ msg.content }}
                    </p>

                    <!-- 图片消息 -->
                    <div class="message-image" v-if="msg.message_type === 2">
                      <img
                        :src="msg.content"
                        :alt="`图片消息 ${index}`"
                        class="message-img"
                        @click="previewImage(msg.content)"
                      />
                    </div>

                    <!-- 文件消息 -->
                    <div class="message-file" v-if="msg.message_type === 3">
                      <a :href="msg.content" target="_blank" class="file-link">
                        <img
                          src="./assets/img/file.png"
                          alt="文件图标"
                          class="file-icon"
                        />
                        <div class="file-info">
                          <span class="file-name">{{
                            getProfileBlock(msg).name
                          }}</span>
                          <span class="file-size">{{
                            msg.file_size || ""
                          }}</span>
                        </div>
                      </a>
                    </div>

                    <!-- 个人信息聚合型消息（自定义类型: 4） -->
                    <div
                      v-if="msg.message_type === 4"
                      class="profile-aggregate"
                      @click="jumpInterviewDetail(msg)"
                    >
                      <div class="pa-left">
                        <div class="pa-title">
                          {{ getProfileBlock(msg).interviewPosition }}
                        </div>
                        <div class="pa-user">
                          <img
                            :src="msg.sender_avatar || default_avatar"
                            class="pa-avatar"
                            alt="avatar"
                          />
                          <div class="pa-user-info">
                            <div class="pa-name-row">
                              <span class="pa-name">{{
                                getProfileBlock(msg).nickname
                              }}</span>
                              <span class="pa-sep">·</span>
                              <span class="pa-basic"
                                >{{ getProfileBlock(msg).sex }} ｜
                                {{ getProfileBlock(msg).age }}岁 ｜
                                {{
                                  getEducationLabel(
                                    getProfileBlock(msg).education
                                  ) || "本科"
                                }}</span
                              >
                            </div>
                            <div class="pa-graduate">{{ "应届" }}</div>
                          </div>
                        </div>
                        <div class="pa-tags">
                          <span></span>
                          <span
                            v-for="(lab, idx) in getProfileBlock(msg).tags || [
                              '0-1 产品经验',
                              'B 端',
                            ]"
                            :key="'pt' + idx"
                            class="pa-tag"
                            >{{ lab }}</span
                          >
                        </div>
                      </div>
                      <div class="pa-right">
                        <div class="pa-score">
                          {{ getProfileBlock(msg).score || "95" }}
                        </div>
                      </div>
                    </div>

                    <span class="read-status">
                      {{
                        is_own_message(msg)
                          ? msg.status === 2
                            ? "已读"
                            : msg.status === 1
                            ? "已发送"
                            : "发送中"
                          : format_time(msg.create_time)
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 空状态（未选择聊天对象） -->
            <div class="empty-chat" v-else>请选择一个会话开始聊天</div>

            <!-- 输入区域 -->
            <div class="input-bar" v-if="current_session">
              <div class="input-icons">
                <img
                  style="width: 24px; height: 23px"
                  @click="triggerFrequent"
                  src="./assets/img/noun-frequent.png"
                  alt="常用语"
                />
                <img
                  style="width: 24px; height: 23px"
                  @click="toggleEmojiPanel"
                  src="./assets/img/noun-emoji.png"
                  alt="表情"
                />
                <img
                  style="width: 24px; height: 23px"
                  @click="triggerFileUpload"
                  src="./assets/img/noun-plus.png"
                  alt="附件"
                />
              </div>
              <div class="input-content">
                <textarea
                  class="input-message"
                  :placeholder="`发送给${
                    current_session ? current_session.title : ''
                  }`"
                  v-model="message_content"
                  @keyup.enter="send_message()"
                  @input="handle_input_typing"
                  rows="2"
                  ref="messageTextarea"
                >
                </textarea>
                <div class="send-button-container">
                  <button class="send-button" @click="send_message()">
                    发送
                  </button>
                </div>
              </div>

              <!-- 隐藏的文件上传输入 -->
              <input
                type="file"
                ref="fileInput"
                class="hidden-file-input"
                @change="handleFileSelected"
              />
            </div>

            <!-- 常用语面板 -->
            <div class="frequent-panel" v-if="showFrequentPanel" @click.stop>
              <div class="frequent-header">
                <h3 class="frequent-title">常用语</h3>
                <button class="frequent-close" @click="closeFrequentPanel">
                  <span>×</span>
                </button>
              </div>
              <div class="frequent-content">
                <div class="frequent-list">
                  <div
                    v-for="(phrase, index) in frequentPhrases"
                    :key="index"
                    class="frequent-item"
                  >
                    <div class="phrase-text">{{ phrase.text }}</div>
                    <div class="phrase-actions">
                      <button
                        class="action-btn delete-btn"
                        @click="deletePhrase(index)"
                      >
                        <span>删除</span>
                      </button>
                      <button
                        class="action-btn modify-btn"
                        @click="modifyPhrase(index)"
                      >
                        <span class="modify-icon">✏️</span>
                        <span>修改</span>
                      </button>
                      <button
                        class="action-btn send-btn"
                        @click="sendPhrase(phrase.text)"
                      >
                        <span>发送</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="add-phrase-section" @click="addPhrase">
                  <div
                    class="add-phrase-box"
                    :class="{ disabled: frequentPhrases.length >= 3 }"
                  >
                    <span class="add-icon">+</span>
                    <span>添加</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 背景遮罩层 -->
            <div
              class="frequent-overlay"
              v-if="showFrequentPanel"
              @click="closeFrequentPanel"
            ></div>
            <div class="emoji-panel" v-if="showEmojiPanel" @click.stop>
              <div class="emoji-category">
                <span class="emoji-title">常用表情</span>
                <div class="emoji-grid">
                  <span
                    v-for="emoji in commonEmojis"
                    :key="emoji"
                    class="emoji-item"
                    @click="selectEmoji(emoji, $event)"
                    >{{ emoji }}</span
                  >
                </div>
              </div>
              <div class="emoji-category">
                <span class="emoji-title">颜文字</span>
                <div class="emoji-grid">
                  <span
                    v-for="emoji in kaomojis"
                    :key="emoji"
                    class="emoji-item"
                    @click="selectEmoji(emoji, $event)"
                    >{{ emoji }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
                    <!-- 删除聊天弹框（Element UI） -->

    </div>

    <el-dialog
      :visible.sync="showDeleteDialog"
      width="445px"
      custom-class="delete-dialog-el"
      :close-on-click-modal="true"
      :show-close="false"
      @close="showDeleteDialog = false"
    >
      <div class="delete-dialog">
        <img :src="tipImgUrl" alt="tip" class="popup-image" />
        <div class="font-color fs-24">确定要删除聊天吗?</div>
        <div class="dd-desc">删除后将清空聊天记录</div>
        <div class="dd-desc">并且将当前聊天从聊天列表中删除</div>
        <div class="dd-actions">
          <button class="dd-btn dd-cancel" @click="showDeleteDialog=false">我再想想</button>
          <button class="dd-btn button-color" @click="confirmDeleteChat">确定删除</button>
        </div>
      </div>
    </el-dialog>

    <!-- 图片预览模态框 -->
    <div
      class="image-preview-modal"
      v-if="previewImageUrl"
      @click="closeImagePreview"
    >
      <div class="preview-content" @click.stop>
        <img :src="previewImageUrl" alt="图片预览" class="preview-img" />
      </div>
    </div>

    <Profile
      @changePopup="handlePopupChange"
      v-if="currentPopup === 'profile'"
    />

    <!-- 修改常用语弹框 -->
    <el-dialog
      :visible.sync="showModifyModal"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="modify-phrase-dialog"
    >
      <div slot="title" class="dialog-title">
        <span class="title-text">{{
          modifyIndex === -1 ? "添加常用语" : "请修改您的常用语"
        }}</span>
        <div class="search-icon">
          <img
            src="./assets/img/close.png"
            class="search-icon-close"
            alt="关闭图标"
            @click="closeModifyModal"
          />
        </div>
      </div>
      <div class="dialog-content">
        <el-input
          v-model="modifyText"
          type="textarea"
          :rows="4"
          placeholder="请输入常用语"
          class="modify-textarea"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer-left">
          <el-button @click="closeModifyModal">返回</el-button>
        </div>
        <div class="footer-right">
          <el-button @click="clearModifyText">清空</el-button>
          <el-button type="primary" @click="saveModifyPhrase">{{
            modifyIndex === -1 ? "添加" : "保存"
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Profile from "@/components/Profile/index.vue";

// 导入聊天接口
import { chatApi, websocketUtil } from "@/api/chat";
import { wsUploadFile, lxUploadFile } from "@/api/upload";
// 导入岗位接口
import { getPositionList } from "@/api/position";
// 导入用户API
import { getBusinessCenter, updateBusinessUser } from "@/api/user";
// 导入常量
import {
  TIME_RANGE_OPTIONS,
  MESSAGE_STATUS_OPTIONS,
  DEFAULT_POSITION_CATEGORIES,
  getEducationLabel,
} from "@/utils/constants";

export default {
  components: {
    Profile,
  },
  data() {
    return {
      statusFilters: {
        unread: false,
        read: false,
        closed: false,
      },
      // 单选消息状态
      selectedMessageStatus: null,
      // 消息状态选项常量
      messageStatusOptions: MESSAGE_STATUS_OPTIONS,
      positionList: [], // 岗位列表
      // 岗位名称相关
      categories: [], // 存储动态获取的分类列表（包含id和name）
      selectedJobCategory: null, // 选中的岗位类别（单选）
      tooltipVisible: false,
      tooltipText: "",
      tooltipX: 0,
      tooltipY: 0,
      timeFilters: {
        today: false,
        oneWeek: false,
        oneMonth: false,
        sixMonths: false,
      },
      // 单选时间范围
      selectedTimeRange: null,
      // 时间范围选项常量
      timeRangeOptions: TIME_RANGE_OPTIONS,
      currentPopup: null,
      sentFileMessages: {}, // 记录已通过WebSocket发送的文件消息,因为发送消息的同时也会给自己发送消息
      jobId: null,
      targetUserType: 1,
      target_user_id: null,
      is_modal_visible: false,
      modal_type: "", // 'edit' 或 'delete'
      editing_name: "",
      status_filters: {
        unread: false,
        read: false,
        closed: false,
      },

      // 时间筛选器
      time_filters: {
        today: false,
        one_week: false,
        one_month: false,
        six_months: false,
      },
      // 基础配置
      default_avatar: require("./assets/img/p1.png"),
      current_user_avatar: require("./assets/img/default-avatar.png"), // 自己的头像
      search_query: "",
      message_content: "", // 输入框内容

      // 聊天核心状态
      chat_sessions: [], // 会话列表
      messages: [], // 当前会话消息
      current_session_id: null, // 当前选中会话ID
      current_session: null, // 当前会话详情

      // 标签栏状态
      currentTab: "all", // 当前选中的tab: 'all', 'favorite', 'locked'
      websocket: null, // WebSocket实例
      heartbeat_timer: null, // 心跳定时器
      typing_status: "", // 对方输入状态
      typing_timer: null, // 输入状态定时器

      // 当前用户信息
      current_user_id: null,
      current_user_type: 2, // 1=普通用户，2=企业用户

      // 分页配置
      pagination: {
        page_no: 1,
        page_size: 20,
        total: 0,
      },

      // 表情包相关
      showEmojiPanel: false,
      commonEmojis: [
        "😀",
        "😂",
        "😍",
        "👍",
        "👏",
        "🙏",
        "😊",
        "😢",
        "😠",
        "🎉",
        "🤔",
        "🙄",
        "😘",
        "😜",
        "🤗",
        "😴",
        "😎",
        "😱",
        "🤩",
        "🙌",
      ],
      kaomojis: [
        "(≧∇≦)ﾉ",
        "(｡•̀ᴗ-)✧",
        "(*^▽^*)",
        "( ´･ᴗ･` )",
        "Σ(°△°|||)",
        "(；¬＿¬)",
        "（￣▽￣）",
        "(*≧▽≦)",
        "(≧∀≦)ゞ",
      ],

      // 常用语相关
      showFrequentPanel: false,
      frequentPhrases: [],
      splitIcon: "$$$$$$",
      // 修改弹框相关
      showModifyModal: false,
      modifyText: "",
      modifyIndex: -1,

      // 文件上传相关
      uploading: false,
      isResetting: false, // 是否正在重置筛选条件

      // 删除确认弹框
      showDeleteDialog: false,
      tipImgUrl: require("./assets/img/tips.png"),

      // 图片预览
      previewImageUrl: "",

      // 用户信息
      userInfo: {
        name: "用户",
        avatar: null,
      },
    };
  },
  computed: {
    ...mapState("user", ["avatar"]),
    // 判断是否为自己发送的消息
    is_own_message() {
      return function (msg) {
        return (
          msg.sender_id === this.current_user_id &&
          msg.sender_type === this.current_user_type
        );
      }.bind(this);
    },

    // 按日期分组消息
    grouped_messages() {
      const groups = {};
      this.messages.forEach((msg) => {
        const date = this.format_date(msg.create_time);
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(msg);
      });
      return groups;
    },
  },
  watch: {
    // 监听筛选条件变化，自动重新加载会话列表
    selectedMessageStatus() {
      // 如果正在重置，不触发加载（由resetFilters统一处理）
      if (!this.isResetting) {
        this.load_sessions();
      }
    },
    selectedTimeRange() {
      if (!this.isResetting) {
        this.load_sessions();
      }
    },
    selectedJobCategory() {
      if (!this.isResetting) {
        this.load_sessions();
      }
    },
  },
  created() {
    // 初始化用户信息
    this.init_user_info();
    // 获取岗位列表
    // this.loadPositionList();
    // 获取分类列表
    this.fetchCategories();
    // 初始化筛选器
    this.initializeFilters();
    // 获取常用语
    this.loadFrequentPhrases();

    // 是否传参
    const q = this.$route.query;
    if (!q.jobId || !q.targetUserId) {
      // 啥也不干
    } else {
      this.jobId = Number(q.jobId);
      this.target_user_id = Number(q.targetUserId);
      chatApi
        .getOrCreateSession({
          job_id: this.jobId,
          target_user_type: 1,
          target_user_id: this.target_user_id,
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.current_session_id = res.data.data.id;
            this.current_session = res.data.data;
            this.load_messages(this.current_session_id);
          }
        });
    }

    // 初始化聊天
    this.init_chat();
  },
  beforeDestroy() {
    // 清理WebSocket连接和定时器
    this.destroy_web_socket();
    if (this.heartbeat_timer) clearInterval(this.heartbeat_timer);
    if (this.typing_timer) clearTimeout(this.typing_timer);
  },
  methods: {
    getEducationLabel,
    // 解析个人信息聚合消息体：支持 content 为 JSON 字符串或 msg.profile 字段
    getProfileBlock(msg) {
      if (!msg) return {};
      if (msg.content && typeof msg.content === "object") return msg.content;
      try {
        if (
          msg.content &&
          typeof msg.content === "string" &&
          (msg.content.startsWith("{") || msg.content.startsWith("["))
        ) {
          const data = JSON.parse(msg.content);
          return Array.isArray(data) ? data[0] || {} : data || {};
        }
      } catch (e) {
        /* ignore parse error */
      }
      return {};
    },
    jumpInterviewDetail(msg) {
      if (msg && msg.message_type === 4) {
        let targetId = "";
        const content = msg.content;
        try {
          const data =
            typeof content === "string" ? JSON.parse(content) : content;
          targetId = data.talentId;
          this.$router.push({
            name: "detail",
            params: { id: targetId },
            query: { interviewId: data.interviewId, jobId: this.jobId },
          });
        } catch (e) {
          // 非 JSON 字符串，忽略
        }
      }
    },
    handlePopupChange(popupType) {
      this.currentPopup = popupType;
    },

    // 获取岗位列表
    async loadPositionList() {
      try {
        const response = await getPositionList({ page_no: 1, page_size: 60 });
        if (response.data.code === 1) {
          this.positionList =
            response.data.data.lists || response.data.data || [];
        } else {
          console.error("获取岗位列表失败:", response.data.msg);
        }
      } catch (error) {
        console.error("获取岗位列表异常:", error);
      }
    },

    // 截断文本并添加省略号
    truncateText(text, maxLength) {
      if (!text) return "";
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + "...";
    },

    // 获取分类列表 - 包含id和name
    async fetchCategories() {
      try {
        // 调用API获取分类列表
        const response = await getPositionList({ status: 1 });

        if (response.data.code === 1) {
          // 使用Map确保分类唯一，保存id和name
          const categoryMap = new Map();

          // 遍历职位列表提取id和category字段
          response.data.data.lists.forEach((item) => {
            if (item.id && item.title && !categoryMap.has(item.id)) {
              categoryMap.set(item.id, {
                id: item.id,
                name: item.title,
              });
            }
          });

          // 转换为数组并赋值
          this.categories = Array.from(categoryMap.values());

          // 初始化jobCategoryFilters
          this.initializeJobCategoryFilters();
        } else {
          this.$message.error(
            "获取分类列表失败: " + (response.data.msg || "未知错误")
          );
          // 出错时使用默认分类
          this.categories = DEFAULT_POSITION_CATEGORIES;

          // 初始化jobCategoryFilters
          this.initializeJobCategoryFilters();
        }
      } catch (error) {
        console.error("获取分类列表出错:", error);
        this.$message.error("获取分类列表失败，请稍后重试");
        // 出错时使用默认分类
        this.categories = DEFAULT_POSITION_CATEGORIES;

        // 初始化jobCategoryFilters
        this.initializeJobCategoryFilters();
      }
    },

    // 初始化岗位类别筛选器
    initializeJobCategoryFilters() {
      this.selectedJobCategory = null;
    },

    // 初始化所有筛选器
    initializeFilters() {
      this.selectedMessageStatus = null;
      this.selectedTimeRange = null;
      this.selectedJobCategory = null;
    },

    // 处理筛选条件变化
    handleFilterChange() {
      this.load_sessions();
    },

    // 处理单选框点击，支持取消选中
    handleRadioClick(field, value) {
      // 延迟执行，让v-model先更新
      this.$nextTick(() => {
        if (field === "messageStatus") {
          if (this.selectedMessageStatus === value) {
            // 如果点击的是已选中的，则取消选中
            this.selectedMessageStatus = null;
          }
        } else if (field === "timeRange") {
          if (this.selectedTimeRange === value) {
            this.selectedTimeRange = null;
          }
        } else if (field === "jobCategory") {
          if (this.selectedJobCategory === value) {
            this.selectedJobCategory = null;
          }
        }
      });
    },

    // 重置所有筛选条件
    resetFilters() {
      // 设置标志，防止watch触发多次加载
      this.isResetting = true;

      // 重置所有筛选条件
      this.selectedMessageStatus = null;
      this.selectedTimeRange = null;
      this.selectedJobCategory = null;
      this.search_query = "";

      // 等待Vue更新完成后，再加载会话列表并清除标志
      this.$nextTick(() => {
        this.load_sessions();
        this.isResetting = false;
      });
    },

    // 关闭弹窗
    closePopup() {
      this.currentPopup = null;
    },
    // 初始化用户信息
    async init_user_info() {
      const { data } = await getBusinessCenter();
      const user_info = data.data;
      this.current_user_id = user_info.id;
      this.current_user_type = 2; // 1: 用户，2: 企业
    },
    // 初始化聊天
    init_chat() {
      // 加载会话列表
      this.load_sessions();
      // 连接WebSocket
      this.connect_web_socket();
    },

    // 连接WebSocket
    connect_web_socket() {
      if (!this.current_user_id || !this.current_user_type) {
        setTimeout(() => this.connect_web_socket(), 1000);
        return;
      }

      this.websocket = websocketUtil.createWebSocket(
        this.current_user_id,
        this.current_user_type
      );

      // 连接成功
      this.websocket.onopen = () => {
        console.log("WebSocket连接成功");
        // 启动心跳
        this.heartbeat_timer = websocketUtil.startHeartbeatTimer(
          this.websocket
        );
      };

      // 接收消息
      this.websocket.onmessage = (event) => {
        console.log("收到消息:", event.data);
        const message = JSON.parse(event.data);
        this.handle_web_socket_message(message);
      };

      // 连接关闭
      this.websocket.onclose = (event) => {
        if (event.code !== 1000) {
          // 非正常关闭才重连
          console.log("尝试重连...");
          setTimeout(() => this.connect_web_socket(), 3000);
        }
      };

      // 连接错误
      this.websocket.onerror = (err) => {
        console.error("WebSocket错误", err);
      };
    },

    // 销毁WebSocket
    destroy_web_socket() {
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },

    // 处理WebSocket消息
    handle_web_socket_message(message) {
      switch (message.type) {
        case "heartbeat":
          // 心跳响应，无需特殊处理
          break;
        case "message":
          // 收到新消息
          this.handle_new_message(message);
          break;
        case "typing":
          // 对方正在输入
          this.typing_status = "正在输入...";
          this.reset_typing_status();
          break;
        case "error":
          this.$message.error("系统提示:" + message.content);
          break;
      }
    },

    // 处理新消息
    handle_new_message(msg) {
      // 忽略自己发送的消息（避免重复显示）
      if (
        msg.senderId === this.current_user_id &&
        msg.senderType === this.current_user_type
      ) {
        return;
      }
      //忽略文件消息
      if (
        (msg.messageType == 2 || msg.messageType == 3) &&
        this.sentFileMessages[`temp_${this.jobId}`]
      ) {
        delete this.sentFileMessages[`temp_${this.jobId}`];
        return;
      }
      // 如果是当前会话的消息，添加到消息列表
      if (msg.sessionId === this.current_session_id) {
        this.$set(this.messages, this.messages.length, msg);
        this.scroll_to_bottom();
        // 标记为已读
        this.mark_as_read(this.current_session_id);
      } else {
        // 非当前会话消息，实时更新会话列表未读计数
        this.load_sessions();
        const sessionIndex = this.chat_sessions.findIndex(
          (s) => s.id === msg.sessionId
        );
        if (sessionIndex !== -1) {
          // 如果会话已存在，直接增加未读计数
          const session = this.chat_sessions[sessionIndex];
          if (!session.business_unread_count) {
            this.$set(session, "business_unread_count", 0);
          }
          this.$set(
            session,
            "business_unread_count",
            session.business_unread_count + 1
          );
          // 更新最后一条消息内容
          this.$set(session, "last_message_content", msg.content);
          this.$set(
            session,
            "last_message_time",
            this.format_time(msg.create_time)
          );
        } else {
          // 如果会话不存在，重新加载会话列表
          this.load_sessions();
        }
      }
      // 浏览器级别新消息通知
      this.showNewMessageNotification(msg);
    },

    // 加载会话列表
    load_sessions() {
      const params = {
        page_no: this.pagination.page_no,
        page_size: this.pagination.page_size,
      };

      // 根据当前tab添加不同的参数
      if (this.currentTab === "favorite") {
        params.favorite = true;
      } else if (this.currentTab === "locked") {
        params.locked = true;
      }

      // 添加搜索参数
      if (this.search_query && this.search_query.trim()) {
        params.keywords = this.search_query.trim();
      }
      // 添加筛选参数（单选逻辑）
      // 对话时间筛选
      if (this.selectedTimeRange !== null) {
        params.timeRangeType = this.selectedTimeRange;
      }

      // 消息状态筛选
      if (this.selectedMessageStatus !== null) {
        params.messageStatus = this.selectedMessageStatus;
      }

      // 岗位类别筛选
      if (this.selectedJobCategory !== null) {
        params.jobId = this.selectedJobCategory;
      }

      chatApi
        .getSessions(params)
        .then((res) => {
          if (res.data.code == 1) {
            // 安全地获取数据，处理不同的数据结构
            let sessions = res.data.data?.records || [];
            sessions = Array.isArray(sessions) ? sessions : [];
            this.chat_sessions = sessions;
            this.pagination.total = this.chat_sessions.length;
          } else {
            this.chat_sessions = [];
            this.pagination.total = 0;
          }
        })
        .catch((err) => {
          console.error("加载会话列表失败", err);
          this.chat_sessions = [];
          this.pagination.total = 0;
        });
    },

    // 浏览器级别的新消息通知
    showNewMessageNotification(msg) {
      // 找到对应的会话
      const session = this.chat_sessions.find((s) => s.id === msg.sessionId);
      if (session) {
        // 显示浏览器通知（需要用户授权）
        if (Notification && Notification.permission === "granted") {
          new Notification(`新消息来自 ${session.title}`, {
            body:
              msg.content.length > 20
                ? msg.content.substring(0, 20) + "..."
                : msg.content,
          });
        } else if (Notification && Notification.permission !== "denied") {
          Notification.requestPermission();
        }
      }
    },

    // 选择会话
    select_session(session) {
      this.current_session_id = session.id;
      this.current_session = session;
      this.jobId = this.current_session.job_id;
      this.messages = [];
      this.message_content = "";

      chatApi
        .getOrCreateSession({
          job_id: this.jobId,
          target_user_type: 1,
          target_user_id: this.current_session.user_id,
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.current_session_id = res.data.data.id;
            this.load_messages(this.current_session_id);
            // 标记为已读
            this.mark_as_read(session.id);
          }
        });
    },

    // 格式化消息日期
    formatMessageDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}/${month}/${day}`;
    },
    // 置顶聊天
    togglePin() {
      if (!this.current_session) return;
      const currentPinned = this.current_session.is_pinned == 1;
      const newPinned = !currentPinned;
      const sessionId = this.current_session.id;
      chatApi
        .operationSession({ session_id: sessionId, is_pinned: newPinned ? 1 : 0 })
        .then(() => {
          // 本地立即更新当前会话和列表中的置顶状态，立刻刷新样式
          this.$set(this.current_session, "is_pinned", newPinned ? 1 : 0);
          const idx = this.chat_sessions.findIndex((s) => s.id === sessionId);
          if (idx !== -1) {
            this.$set(this.chat_sessions[idx], "is_pinned", newPinned ? 1 : 0);
          }
          this.$message.success(newPinned ? "已置顶" : "已取消置顶");
          // 可选：重新拉取会话列表，保证顺序最新
          this.load_sessions();
        })
        .catch((err) => {
          console.error("置顶操作失败:", err);
          this.$message.error("置顶失败，请稍后重试");
        });
    },

    // 免打扰
    toggleMute() {
      if (!this.current_session) return;
      const currentMuted = this.current_session.is_muted == 1;
      const newMuted = !currentMuted;
      const sessionId = this.current_session.id;
      chatApi
        .operationSession({ session_id: sessionId, is_muted: newMuted ? 1 : 0 })
        .then(() => {
          // 直接更新当前会话状态
          this.$set(this.current_session, "is_muted", newMuted ? 1 : 0);
          // 同时更新会话列表中的对应会话
          const sessionIndex = this.chat_sessions.findIndex(
            (s) => s.id === sessionId
          );
          if (sessionIndex !== -1) {
            this.$set(
              this.chat_sessions[sessionIndex],
              "is_muted",
              newMuted ? 1 : 0
            );
          }
          this.$message.success(newMuted ? "已开启免打扰" : "已关闭免打扰");
        })
        .catch((err) => {
          console.error("免打扰操作失败:", err);
          this.$message.error("免打扰失败，请稍后重试");
        });
    },

    // 删除聊天
    deleteChat() {
      if (this.current_session) {
        this.showDeleteDialog = true;
      }
    },

    // 确认删除聊天
    confirmDeleteChat() {
      if (!this.current_session) return;
      const sessionId = this.current_session.id;
      chatApi
        .operationSession({ session_id: sessionId, is_deleted: 1 })
        .then(() => {
          this.$message.success("删除成功");
          // 清空当前会话窗口
          this.current_session = null;
          this.current_session_id = null;
          this.messages = [];
          this.message_content = "";
          // 删除成功后刷新会话列表
          this.load_sessions();
          this.showDeleteDialog = false;
        })
        .catch((err) => {
          console.error("删除聊天失败:", err);
          this.$message.error("删除失败，请稍后重试");
        });
    },

    // 加载会话消息
    load_messages(session_id) {
      chatApi
        .getMessages({
          sessionId: session_id,
          pageNo: 1,
          pageSize: 50,
        })
        .then((res) => {
          if (res.data.code === 1) {
            // 确保消息按时间升序排列（最新消息在最后）
            this.messages = res.data.data.sort(
              (a, b) => new Date(a.create_time) - new Date(b.create_time)
            );
            console.log("获取消息列表", this.messages);
            this.scroll_to_bottom();
          }
        })
        .catch((err) => {
          console.error("加载消息失败", err);
        });
    },

    // 发送消息
    send_message(content = null, messageType = 1) {
      const jobId = this.jobId;
      // 防止传入事件对象
      if (content && typeof content !== "string") {
        content = null;
      }
      if ((!content && !this.message_content.trim()) || !this.current_session)
        return;

      // 确定消息内容和类型
      const msgContent = content || this.message_content.trim();
      const msgType = messageType;

      // 清空输入框（如果是文本消息）
      if (msgType === 1) {
        this.message_content = "";
      }

      // WebSocket连接正常则实时发送
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        const msg_data = {
          type: "chat",
          receiverId: this.current_session.user_id,
          receiverType: 1,
          content: msgContent,
          messageType: msgType,
          jobId,
        };
        console.log("发送消息数据", msg_data);

        // 构建本地临时消息
        const temp_msg = {
          id: `temp_${Date.now()}`,
          sender_id: this.current_user_id,
          sender_type: this.current_user_type,
          receiver_id: this.current_session.user_id,
          receiver_type: 1, // 固定为普通用户
          content: msgContent,
          message_type: msgType,
          session_id: this.current_session_id,
          status: 0, // 0:发送中
        };

        // 乐观更新：添加到消息列表
        this.messages.push(temp_msg);
        this.scroll_to_bottom();
        websocketUtil.sendChatMessage(this.websocket, msg_data);

        // 更新消息状态为已发送
        const msg_index = this.messages.findIndex((m) => m.id === temp_msg.id);
        if (msg_index !== -1) {
          this.messages[msg_index].status = 1;
          console.log("使用了在线发送");
        }
      } else {
        const msg_data = {
          receiver_id: this.current_session.user_id,
          receiver_type: 1,
          content: msgContent,
          message_type: msgType,
          job_id: jobId,
        };
        console.log("发送消息数据", msg_data);
        console.log("使用了离线发送");

        // 否则发送离线消息
        chatApi
          .sendMessage(msg_data)
          .then((res) => {
            if (res.data.code === 1) {
              // 替换本地临时消息为服务器返回的消息
              const msg_index = this.messages.findIndex(
                (m) => m.id === msg_data.id
              );
              if (msg_index !== -1) {
                this.messages[msg_index] = res.data.data;
              } else {
                this.messages.push(res.data.data);
              }
              this.scroll_to_bottom();
            }
          })
          .catch((err) => {
            console.error("发送离线消息失败", err);
            // 发送失败，更新消息状态
            const msg_index = this.messages.findIndex(
              (m) => m.id === msg_data.id
            );
            if (msg_index !== -1) {
              this.messages[msg_index].status = -1; // 发送失败状态
            }
          });
      }
    },

    // 触发文件上传
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    // 处理常用语
    triggerFrequent() {
      this.showFrequentPanel = !this.showFrequentPanel;
      if (this.showFrequentPanel) {
        this.showEmojiPanel = false; // 关闭表情包面板
      }
    },

    // 关闭常用语面板
    closeFrequentPanel() {
      this.showFrequentPanel = false;
    },

    // 发送常用语
    sendPhrase(text) {
      this.message_content = text;
      this.send_message();
      this.closeFrequentPanel();
    },

    // 加载常用语
    async loadFrequentPhrases() {
      try {
        const response = await getBusinessCenter();
        if (response.data.code === 1) {
          const userInfo = response.data.data || {};
          this.userInfo = userInfo;
          this.frequentPhrases = this.convertGreetingsToArray(
            userInfo.greetings
          ).map((text) => ({ text }));
        } else {
          console.error("获取常用语失败：", response.data.msg);
        }
      } catch (error) {
        console.error("获取常用语异常：", error);
      }
    },

    // 将后端返回的字符串转换为数组
    convertGreetingsToArray(greetings) {
      if (!greetings) return [];
      if (typeof greetings === "string") {
        if (greetings.trim() === "") return [];
        return greetings
          .split(this.splitIcon)
          .filter((item) => item.trim() !== "");
      }
      if (Array.isArray(greetings)) {
        return greetings.length > 0 ? greetings : [];
      }
      return [];
    },

    // 将前端数组转换为后端需要的字符串
    convertGreetingsToString(greetings) {
      if (!greetings || !Array.isArray(greetings)) return "";
      const validGreetings = greetings.filter(
        (item) => item && item.trim() !== ""
      );
      return validGreetings.join(this.splitIcon);
    },

    // 删除常用语
    async deletePhrase(index) {
      try {
        const newPhrases = [...this.frequentPhrases];
        newPhrases.splice(index, 1);

        const greetingsString = this.convertGreetingsToString(
          newPhrases.map((p) => p.text)
        );

        const updateData = {
          ...this.userInfo,
          greetings: greetingsString,
        };

        const response = await updateBusinessUser(updateData);
        if (response.data.code === 1) {
          this.frequentPhrases = newPhrases;
          this.$message.success("删除成功");
        } else {
          this.$message.error(response.data.msg || "删除失败");
        }
      } catch (error) {
        console.error("删除常用语失败:", error);
        this.$message.error("删除失败，请重试");
      }
    },

    // 修改常用语
    modifyPhrase(index) {
      this.modifyIndex = index;
      this.modifyText = this.frequentPhrases[index].text;
      this.showModifyModal = true;
    },

    // 关闭修改弹框
    closeModifyModal() {
      this.showModifyModal = false;
      this.modifyText = "";
      this.modifyIndex = -1;
    },

    // 清空修改文本
    clearModifyText() {
      this.modifyText = "";
    },

    // 保存修改的常用语
    async saveModifyPhrase() {
      if (!this.modifyText.trim()) {
        this.$message.warning("请输入常用语内容");
        return;
      }

      if (this.modifyIndex === -1) {
        // 添加模式
        if (this.frequentPhrases.length >= 3) {
          this.$message.warning("最多只能添加3条常用语");
          return;
        }

        try {
          const newPhrases = [
            ...this.frequentPhrases,
            { text: this.modifyText.trim() },
          ];
          const greetingsString = this.convertGreetingsToString(
            newPhrases.map((p) => p.text)
          );

          const updateData = {
            ...this.userInfo,
            greetings: greetingsString,
          };

          const response = await updateBusinessUser(updateData);
          if (response.data.code === 1) {
            this.frequentPhrases = newPhrases;
            this.closeModifyModal();
            this.$message.success("添加成功");
          } else {
            this.$message.error(response.data.msg || "添加失败");
          }
        } catch (error) {
          console.error("添加常用语失败:", error);
          this.$message.error("添加失败，请重试");
        }
      } else {
        // 编辑模式
        if (
          this.modifyText.trim() === this.frequentPhrases[this.modifyIndex].text
        ) {
          this.closeModifyModal();
          return;
        }

        try {
          const newPhrases = [...this.frequentPhrases];
          newPhrases[this.modifyIndex].text = this.modifyText.trim();

          const greetingsString = this.convertGreetingsToString(
            newPhrases.map((p) => p.text)
          );

          const updateData = {
            ...this.userInfo,
            greetings: greetingsString,
          };

          const response = await updateBusinessUser(updateData);
          if (response.data.code === 1) {
            this.frequentPhrases = newPhrases;
            this.closeModifyModal();
            this.$message.success("修改成功");
          } else {
            this.$message.error(response.data.msg || "修改失败");
          }
        } catch (error) {
          console.error("修改常用语失败:", error);
          this.$message.error("修改失败，请重试");
        }
      }
    },

    // 添加常用语
    addPhrase() {
      this.modifyIndex = -1; // -1表示添加模式
      this.modifyText = "";
      this.showModifyModal = true;
    },

    // 处理文件选择
    handleFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 清空文件输入，以便可以重复选择同一个文件
      event.target.value = "";

      // 判断文件类型
      const isImage = file.type.startsWith("image/");
      const messageType = isImage ? 2 : 3;

      this.uploading = true;

      // 准备上传参数
      const params = {
        senderId: this.current_user_id,
        senderType: this.current_user_type,
        receiverId: this.current_session.user_id,
        receiverType: 1,
        messageType: messageType,
        jobId: this.jobId,
        dir: isImage ? "images" : "files",
      };

      // 构建FormData，确保文件名正确编码
      const formData = new FormData();
      // 使用原始文件名，确保UTF-8编码
      formData.append("file", file, file.name);

      // 添加文件名参数，确保服务器能正确接收
      formData.append("fileName", encodeURIComponent(file.name));
      formData.append("fileSize", file.size.toString());
      formData.append("fileType", file.type);

      // 优先使用WebSocket上传
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        // 使用wsUploadFile接口上传
        wsUploadFile(params, formData)
          .then((response) => {
            this.uploading = false;
            if (response.data.code == 1 && response.data.data.url) {
              // 上传成功，发送文件消息
              this.send_message(
                JSON.stringify(response.data.data),
                messageType
              );
              // 上传成功后添加标记
              this.sentFileMessages[`tem_` + this.jobId] = true;

              // 添加文件大小和文件名信息到最后一条消息
              if (this.messages.length > 0) {
                const lastMsgIndex = this.messages.length - 1;
                this.messages[lastMsgIndex].file_size = this.formatFileSize(
                  file.size
                );
                this.messages[lastMsgIndex].original_file_name = file.name;
              }
            } else {
              this.$message.error(
                "文件上传失败: " + (response.message || "未知错误")
              );
            }
          })
          .catch((error) => {
            this.uploading = false;
            console.error("WebSocket文件上传失败", error);
            this.$message.error("文件上传失败，请重试");
          });
      } else {
        // 使用离线上传接口
        lxUploadFile(formData)
          .then((response) => {
            this.uploading = false;
            if (response.data.code === 1 && response.data.data.url) {
              // 上传成功，发送文件消息
              this.send_message(
                JSON.stringify(response.data.data),
                messageType
              );

              // 添加文件大小和文件名信息到最后一条消息
              if (this.messages.length > 0) {
                const lastMsgIndex = this.messages.length - 1;
                this.messages[lastMsgIndex].file_size = this.formatFileSize(
                  file.size
                );
                this.messages[lastMsgIndex].original_file_name = file.name;
              }
            } else {
              this.$message.error(
                "文件上传失败: " + (response.data.message || "未知错误")
              );
            }
          })
          .catch((error) => {
            this.uploading = false;
            console.error("离线文件上传失败", error);
            this.$message.error("文件上传失败，请重试");
          });
      }
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // 获取文件名
    getFileName(url) {
      if (!url) return "未知文件";

      try {
        // 从URL中提取文件名
        const parts = url.split("/");
        let fileName = parts[parts.length - 1].split("?")[0];

        // 解码URL编码的文件名
        fileName = decodeURIComponent(fileName);
        console.log(fileName, "fileName");

        // 如果文件名仍然包含编码字符，尝试进一步处理
        if (fileName.includes("%")) {
          fileName = decodeURIComponent(fileName);
        }

        return fileName;
      } catch (error) {
        // 如果解码失败，返回原始文件名
        const parts = url.split("/");
        return parts[parts.length - 1].split("?")[0];
      }
    },

    // 判断是否应该显示日期分割线
    shouldShowDateDivider(msg, index) {
      if (index === 0) return true; // 第一条消息总是显示日期

      const currentDate = this.formatMessageDate(msg.create_time);
      const prevMsg = this.messages[index - 1];
      const prevDate = this.formatMessageDate(prevMsg.create_time);

      return currentDate !== prevDate;
    },

    // 切换表情包面板
    toggleEmojiPanel() {
      this.showEmojiPanel = !this.showEmojiPanel;
    },

    // 选择表情
    selectEmoji(emoji) {
      this.message_content += emoji;
      this.showEmojiPanel = false;
    },

    // 预览图片
    previewImage(url) {
      this.previewImageUrl = url;
    },

    // 关闭图片预览
    closeImagePreview() {
      this.previewImageUrl = "";
    },

    // 标记消息为已读
    mark_as_read(session_id) {
      chatApi
        .markAsRead(session_id)
        .then((res) => {
          if (res.data.code === 1) {
            // 更新会话未读状态
            const sessionIndex = this.chat_sessions.findIndex(
              (s) => s.id === session_id
            );
            if (sessionIndex !== -1) {
              const session = this.chat_sessions[sessionIndex];
              this.$set(session, "business_unread_count", 0);
            }
            const session = this.chat_sessions.find((s) => s.id === session_id);
            if (session) session.user_unread_count = 0;
          }
        })
        .catch((err) => {
          console.error("标记已读失败", err);
        });
    },

    // 处理输入状态（通知对方正在输入）
    handle_input_typing() {
      if (!this.current_session) return;

      // 清除之前的定时器
      if (this.typing_timer) clearTimeout(this.typing_timer);

      // 发送正在输入状态（仅WebSocket连接时）
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        this.websocket.send(
          JSON.stringify({
            type: "typing",
            receiver_id:
              this.current_session.business_id || this.current_session.user_id,
            receiver_type: this.current_session.business_id ? 2 : 1,
          })
        );
      }

      // 3秒后清除输入状态
      this.typing_timer = setTimeout(() => {
        this.typing_status = "";
      }, 3000);
    },

    // 重置输入状态
    reset_typing_status() {
      if (this.typing_timer) clearTimeout(this.typing_timer);
      this.typing_timer = setTimeout(() => {
        this.typing_status = "";
      }, 3000);
    },

    // 滚动到消息底部
    scroll_to_bottom() {
      this.$nextTick(() => {
        const content_el = this.$el.querySelector(".chat-content");
        if (content_el) content_el.scrollTop = content_el.scrollHeight;
      });
    },

    // 格式化时间显示（时分）
    format_time(time_str) {
      if (!time_str) return "";
      const date = new Date(time_str);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    // 格式化日期显示（年月日）
    format_date(time_str) {
      if (!time_str) return "";
      const date = new Date(time_str);
      return date.toLocaleDateString();
    },

    // 查看当前聊天对象简历
    view_current_user_resume() {
      console.log("查看简历", this.current_session);
      this.$message.info("跳转至简历页面");
    },

    // 切换标签页
    switchTab(tab) {
      if (this.currentTab === tab) {
        return; // 如果点击的是当前tab，不重复处理
      }

      this.currentTab = tab;
      // 重置分页
      this.pagination.page_no = 1;

      // 重新加载会话列表
      this.load_sessions();

      // 清空当前选中的会话
      this.current_session_id = null;
      this.current_session = null;
      this.messages = [];
    },

    // 搜索处理
    handle_search() {
      console.log("搜索:", this.search_query);
      // 重置分页到第一页进行搜索
      this.pagination.page_no = 1;
      this.load_sessions();
    },


  },
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />
<style scoped lang="css" src="./assets/candidate.css" />
<style scoped lang="scss">
/* 页面内不再放置头像，样式删除 */
/* 自定义样式 */
.left {
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: linear-gradient(
    180deg,
    rgba(177, 110, 249, 0.1) 0%,
    rgba(126, 180, 235, 0.1) 100%
  );
  border-radius: 26px;
  border: 1px solid #a47ff6;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(27.85px);
  margin-right: -1.5vw;
}

.div42 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-left: 20px;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.image5 {
  width: 100%;
  height: 60%;
  object-fit: cover;
  border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
  padding: 20px;
  overflow-y: auto;
  height: calc(100% - 80px);
}

.vector-1 {
  width: 100%;
  height: auto;
}

.div13 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}

.div14 {
  color: #ffffff;
  text-align: center;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-decoration: none;
  line-height: 32px;
}

._1 {
  position: absolute;
  width: 13vw;
  min-width: 180px;
  height: auto;
  top: 3vh;
  left: 0;
  z-index: 0;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  height: 28vh;
  width: 22vw;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 1vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 1.5vw;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(126, 180, 235, 0.3);
}





.user-profile {
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 2vw;
}

.avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  margin-right: 10px;
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
}

.username {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-card {
  border: 1px solid #7eb4eb !important;
  border-image: none !important;
}

.sidebar {
  border: none !important;
  border-radius: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 20% !important;
  padding-top: 0px;
}

.rcktext {
  font-family: Afacad;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  background: var(
    --linear-2-paints,
    linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.chat-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 120px); /* 固定高度，减去页面其他部分的高度 */
  min-height: 500px;
  background-color: transparent;

  .left-panel {
    width: 40%;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* 防止整个面板滚动 */
  }

  .chat-list {
    overflow-y: auto;
    flex: 1;
    padding: 8px 0;
    min-height: 0; /* 重要：允许flex子项收缩 */

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }

    -ms-overflow-style: none;
    scrollbar-width: thin;
  }

  .chat-item {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    border-radius: 16px;
    background: white;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    margin-bottom: 12px;
    box-sizing: border-box;
    position: relative;
    transition: all 0.3s ease;
    min-height: 90px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
      border-color: #b16ef9;
    }

    &.active {
      background: white;
      border: 2px solid #b16ef9;
      box-shadow: 0 8px 24px rgba(126, 180, 235, 0.15);
      transform: translateY(-1px);
    }
  }

  .avatar-container {
    position: relative;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .unread-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 10px;
    height: 10px;
    background-color: #ff4757;
    border-radius: 50%;
    border: 2px solid white;
    z-index: 3;
    box-shadow: 0 2px 4px rgba(255, 71, 87, 0.3);
  }

  .avatar-container {
    position: relative;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .unread-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 10px;
    height: 10px;
    background-color: #ff4757;
    border-radius: 50%;
    border: 2px solid white;
    z-index: 3;
    box-shadow: 0 2px 4px rgba(255, 71, 87, 0.3);
  }

  .chat-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .name-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 6px;
  }

  .name {
    font-family: Source Han Sans CN VF;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    vertical-align: middle;
    color: #656587;
  }

  .position-tag {
    display: inline-block;
    border: 1px solid rgba(177, 110, 249, 0.3);
    border-radius: 4px;
    background: transparent;
    -webkit-background-clip: text;
    font-size: 13px;
    font-weight: 600;
    align-self: flex-start;
    margin-bottom: 8px;
    color: #656587;
    padding: 2px;
    margin: 4px 0;
    background-image: linear-gradient(90deg, #7eb4eb, #b16ef9);
    border: 1px solid;
    -o-border-image: linear-gradient(90deg, #7eb4eb, #b16ef9) 1;
    border-image: linear-gradient(90deg, #7eb4eb, #b16ef9) 1;
  }

  .message-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .last-message {
    flex: 1;
    font-size: 14px;
    color: #65658780;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 12px;
    line-height: 1.4;
    font-weight: 400;
  }

  .timestamp {
    font-size: 14px;
    color: #65658780;
    white-space: nowrap;
    flex-shrink: 0;
    font-weight: 400;
  }

  .right-panel {
    margin-left: 20px;
    margin-top: 56px;
    width: 55%;
    box-sizing: border-box;
    border-radius: 24px;
    box-shadow: 1px 1px 10px 0px #0000000d;
    backdrop-filter: blur(30px);
    display: flex;
    flex-direction: column;
    overflow: hidden; /* 防止整个面板滚动 */
    position: relative;
  }

  .chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: white;
    border-radius: 12px 12px 0 0;

    .user-info {
      display: flex;
      flex-direction: row;
      gap: 4px;
    }

    .user-name {
      font-family: Afacad;
      font-weight: 600;
      font-size: 18px;
      color: #2d2d2d;
    }

    .company-tag {
      display: inline-block;
      padding: 4px 8px;
      background: rgba(177, 110, 249, 0.1);
      border: 1px solid #b16ef9;
      border-radius: 6px;
      font-size: 12px;
      color: #b16ef9;
      font-weight: 500;
      width: fit-content;
    }

    .typing-status {
      font-size: 14px;
      color: #999;
      font-style: italic;
    }

    .action-buttons {
      display: flex;
      align-items: center;
    }

    .action-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 6px 12px;
      border: none;
      background: transparent;
      border-radius: 6px;
      font-size: 14px;
      color: #656587;
      cursor: pointer;
      transition: all 0.2s;

      img {
        width: 18px;
        height: 18px;
        opacity: 0.6;
        transition: opacity 0.2s ease;
      }

      &.active {
        color: #b16ef9;
        background: rgba(177, 110, 249, 0.1);

        img {
          opacity: 1;
        }
      }
    }
  }





  .button-color {
    background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
    color: white;
    border: none;
  }

  .chat-name {
    font-family: Afacad;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    color: #656587;
  }

  .input-status {
    font-size: 14px;
    color: #7b68ee;
    font-style: italic;
    font-weight: 500;
    background: rgba(123, 104, 238, 0.1);
    padding: 4px 12px;
    border-radius: 16px;
    border: 1px solid rgba(123, 104, 238, 0.2);
  }

  .view-resume {
    padding: 5px 10px;
    cursor: pointer;
    font-family: Afacad;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: #00000066;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background-color 0.2s;
    border-radius: 5px;

    &:hover {
      background-color: rgba(177, 110, 249, 0.1);
    }
  }

  .chat-content {
    overflow-y: auto;
    flex: 1;
    background: linear-gradient(
      320.78deg,
      rgba(255, 255, 255, 0.4) 2.06%,
      rgba(255, 255, 255, 0.723077) 42.17%,
      rgba(255, 255, 255, 0.8) 99.08%
    );
    border-radius: 0px;
    padding: 0 20px;
    box-shadow: 1px 1px 10px 0px #0000000d;
    backdrop-filter: blur(30px);

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }
  }

  .date-divider {
    text-align: center;
    margin: 15px 0 10px 0;
    color: #999;
    font-size: 12px;
    position: relative;
    width: 100%;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      width: 40%;
      height: 1px;
      background-color: #e0e0e0;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  .message-item {
    margin-bottom: 15px;
    display: flex;
    max-width: 80%;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .mine {
    flex-direction: row-reverse;
    margin-left: auto;
  }

  .other {
    justify-content: flex-start;
    margin-right: auto;
  }

  .message-bubble {
    display: flex;
    flex-direction: column;
  }

  .message-text {
    padding: 10px 15px;
    border-radius: 10px;
    margin: 0;
    max-width: 100%;
    word-wrap: break-word;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;
    white-space: normal;
  }

  .message-image {
    padding: 5px;
    border-radius: 10px;

    .message-img {
      max-width: 200px;
      max-height: 200px;
      border-radius: 8px;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .message-file {
    padding: 10px 15px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid #e0e0e0;
    max-width: 300px;

    .file-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: #656587;

      .file-icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }

      .file-info {
        flex: 1;
        overflow: hidden;

        .file-name {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 400;
        }

        .file-size {
          display: block;
          font-size: 12px;
          color: #999;
        }
      }

      &:hover {
        color: #7eb4eb;
      }
    }
  }

  .other .message-text,
  .other .message-file {
    background: linear-gradient(
      320.78deg,
      rgba(255, 255, 255, 0.8) 2.06%,
      rgba(255, 255, 255, 0.5) 99.08%
    );
    border: 1px solid #e0e0e0;
    border-top-left-radius: 0;
  }

  .mine .message-text,
  .mine .message-file {
    background: linear-gradient(
      320.78deg,
      rgba(177, 110, 249, 0.2) 2.06%,
      rgba(126, 180, 235, 0.2) 99.08%
    );
    border: 1px solid #d8c5f7;
    border-top-right-radius: 0;
    max-width: 360px;
  }

  .read-status {
    font-size: 12px;
    color: #999;
    margin-top: 3px;
    align-self: flex-end;
  }

  .other .read-status {
    padding-left: 15px;
  }

  .mine .read-status {
    padding-right: 15px;
  }

  .other-avatar {
    margin-right: 10px;
    margin-left: 0;
  }

  .my-avatar {
    margin-left: 10px;
    margin-right: 0;
  }

  .input-bar {
    padding: 8px 12px;
    border-radius: 0 0 25px 25px;
    box-shadow: 0px -2px 10px 0px #0000000d;
    margin-top: auto;
    background-color: #fff;
    max-height: 136px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .input-icons {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .input-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .send-button-container {
    display: flex;
    justify-content: flex-end;
  }

  .input-message {
    width: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 14px;
    color: #656587;
    min-height: 40px;
    max-height: 80px;
    resize: none;
    overflow-y: auto;
    font-family: inherit;
    line-height: 1.4;

    &::placeholder {
      color: #bbb;
    }
  }

  .send-emoji,
  .send-attachment {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    margin: 0 5px;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  .send-button {
    background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
    color: white;
    border: none;
    border-radius: 4px;
    padding: 4px 16px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
      transform: scale(1.05);
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      opacity: 1;
    }
  }

  .empty-chat {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 22px;
    color: #999;
    border: 1px dashed #e0e0e0;
    border-radius: 10px;
  }
}


/* 删除确认弹框样式（Element UI 内容区域） */
.delete-dialog-el {
  border-radius: 24px;
  overflow: visible;
}

/* 隐藏 ElementUI 默认头部，只用自定义内容 */
::v-deep .delete-dialog-el .el-dialog__header {
  display: none;
}

::v-deep .delete-dialog-el .el-dialog__body {
  padding: 32px 48px 28px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 24px;
}

.delete-dialog {
  text-align: center;
}

.popup-image {
  width: 180px;
  height: auto;
  margin: 0 auto 12px;
  display: block;
}

.font-color {
  color: #333;
}

.fs-24 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.dd-desc {
  font-size: 14px;
  color: #656587;
  margin: 4px 0;
}

.dd-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
}

.dd-btn {
  padding: 4px 0;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  flex: 1;
  min-width: 140px;
}

.dd-cancel {
  border: 1px solid #D0D2E0;
  background: #fff;
  color: #656587;
}

.button-color {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: #fff;
  border: none;
}

/* 常用语面板样式 */
.frequent-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  max-height: 60vh;
  overflow: hidden;
  animation: slideUpFromBottom 0.3s ease-out;
}

@keyframes slideUpFromBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 背景遮罩层 */
.frequent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.frequent-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.frequent-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.frequent-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  border: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.frequent-close:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(98, 175, 255, 0.4);
}

.frequent-content {
  padding: 16px 20px 20px 20px;
  max-height: calc(60vh - 80px);
  overflow-y: auto;
}

.frequent-list {
  margin-bottom: 16px;
}

.frequent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.frequent-item:last-child {
  border-bottom: none;
}

.phrase-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  margin-right: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.phrase-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.delete-btn {
  background: transparent;
  color: #666;
  padding: 4px 8px;
  border: none;
}

.delete-btn:hover {
  background: transparent;
  color: #f44336;
}

.modify-btn {
  background: transparent;
  color: #666;
  padding: 4px 8px;
  border: none;
}

.modify-btn:hover {
  background: transparent;
  color: #2196f3;
}

.send-btn {
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  color: white;
  border: 1px solid transparent;
  padding: 6px 12px;
  border-radius: 6px;
}

.send-btn:hover {
  opacity: 0.9;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(98, 175, 255, 0.4);
}

.add-phrase-section {
  margin-top: 16px;
}

.add-phrase-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px;
  border: 2px dashed #62afff;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #62afff;
  font-size: 14px;
}

.add-phrase-box:hover:not(.disabled) {
  border-color: #9c41ff;
  color: #9c41ff;
  background: rgba(98, 175, 255, 0.05);
}

.add-phrase-box.disabled {
  border-color: #ccc;
  color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-phrase-box.disabled .add-icon {
  background: #ccc;
}

/* Element UI 修改常用语弹框自定义样式 */
.modify-phrase-dialog {
  border-radius: 16px;
}

/* 使用Vue深度选择器 */
::v-deep .modify-phrase-dialog .el-dialog__header {
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4)) !important;
  padding: 20px 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  position: relative !important;
}

.modify-phrase-dialog .dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.modify-phrase-dialog .title-text {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-align: left !important;
}

.modify-phrase-dialog .el-dialog__body {
  padding: 24px;
}

.modify-phrase-dialog .modify-textarea {
  min-height: 120px;
}

.modify-phrase-dialog .modify-textarea .el-textarea__inner {
  border: 2px solid #e5e5e5;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.2s ease;
}

.modify-phrase-dialog .modify-textarea .el-textarea__inner:focus {
  border-color: #62afff;
}

.modify-phrase-dialog .el-dialog__footer {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modify-phrase-dialog .dialog-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modify-phrase-dialog .footer-left {
  display: flex;
}

.modify-phrase-dialog .footer-right {
  display: flex;
  gap: 12px;
}

.modify-phrase-dialog .dialog-footer .el-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}

.modify-phrase-dialog .dialog-footer .el-button--default {
  border: 2px solid #9c41ff;
  color: #9c41ff;
  background: white;
}

.modify-phrase-dialog .dialog-footer .el-button--primary {
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  border: none;
  color: white;
}

.modify-phrase-dialog .dialog-footer .el-button--primary:hover {
  opacity: 0.9;
}

.add-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.add-phrase-box span:last-child {
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 500;
}

.add-phrase-form {
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.phrase-input {
  width: 100%;
  min-height: 60px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;
}

.phrase-input:focus {
  border-color: #62afff;
  box-shadow: 0 0 0 2px rgba(98, 175, 255, 0.1);
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-end;
}

.confirm-add,
.cancel-add {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.confirm-add {
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  color: white;
}

.confirm-add:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.cancel-add {
  background: #f5f5f5;
  color: #666;
}

.cancel-add:hover {
  background: #e0e0e0;
}

/* 表情包面板样式 */
.emoji-panel {
  position: absolute;
  bottom: 70px;
  left: 10px;
  right: 10px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
}

.emoji-category {
  margin-bottom: 10px;
}

.emoji-title {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 5px;
}

.emoji-item {
  font-size: 18px;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
}

/* 隐藏的文件上传输入 */
.hidden-file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.preview-content {
  max-width: 90%;
  max-height: 90%;
}

.preview-img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 5px;
}

.sidebar-footer {
  position: absolute;
  bottom: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #b16ef9;
  }
}

.settings-icon {
  width: 20px;
  height: 20px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
  flex-shrink: 0; /* 防止收缩 */
  z-index: 10;
  height: 40px;
  background: transparent;
}

.search-input {
  width: 100%;
  height: 100%;

  outline: none;
  font-size: 14px;
  background-color: transparent;

  &:focus {
    border-color: #b16ef9;
    box-shadow: 0 0 0 2px rgba(177, 110, 249, 0.1);
  }
}

.search-icon-container {
  position: absolute;
  right: 0px;
  border: 0px;
  border-left: 1px solid var(--Linear, #b16ef9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 8px;
}

.search-icon-img {
  width: 18px;
  height: 18px;
}

/* 单选框样式 - 保持与多选框一致的颜色 */
.checkbox-item input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #b16ef9;
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;
  position: relative;
  margin-right: 8px;
  transition: all 0.2s ease;
}

.checkbox-item input[type="radio"]:checked {
  background: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
  border-color: transparent;
}

.checkbox-item input[type="radio"]:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 50%;
}

.checkbox-item input[type="radio"]:hover {
  border-color: #9c41ff;
  box-shadow: 0 0 0 2px rgba(156, 65, 255, 0.1);
}

.category-tags {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  overflow-x: auto;
  padding-bottom: 5px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
}

.category-tag {
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  background-color: #f5f5f5;
  color: #666;
  transition: all 0.2s;

  &.active {
    background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
    color: white;
  }

  &:hover:not(.active) {
    background-color: #e9e9e9;
  }
}

/* 标签栏样式 */
.tab-bar {
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0; /* 防止收缩 */
  z-index: 10;
  position: relative;

  .tab-item {
    padding: 10px 20px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;

    &.active {
      color: #7eb4eb;
      border-bottom-color: #7eb4eb;
      background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &:hover:not(.active) {
      color: #999;
      background-color: rgba(126, 180, 235, 0.1);
    }
  }
}

/* 聊天头部按钮样式 */
.favorite-btn,
.more-btn {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    color: #7b68ee;
    background: rgba(123, 104, 238, 0.1);
    border-color: rgba(123, 104, 238, 0.3);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(123, 104, 238, 0.2);
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
}

.favorite-btn {
  &:hover {
    color: #ff6b6b;
    background: rgba(255, 107, 107, 0.1);
    border-color: rgba(255, 107, 107, 0.3);
  }
}

.profile-aggregate {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  background: linear-gradient(
    320.78deg,
    rgba(255, 255, 255, 0.8) 2.06%,
    rgba(255, 255, 255, 0.5) 99.08%
  );
  border: 1px solid #e0e0e0;
  max-width: 450px;
  animation: fadeIn 0.3s ease;
}

.other .profile-aggregate {
  border-top-left-radius: 0;
}

.pa-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.pa-title {
  font-size: 16px;
  font-weight: 700;
  color: #2d2d2d;
}

.pa-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pa-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.pa-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pa-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.pa-sep {
  color: #999;
  font-weight: 400;
}

.pa-basic {
  font-size: 12px;
  color: #777;
  font-weight: 400;
}

.pa-graduate {
  font-size: 12px;
  color: #6b45e4;
}

.pa-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pa-tag {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  font-size: 12px;
  background: transparent;
  border: 1px solid;
  border-image: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%) 1;
  border-radius: 11px;
}

.pa-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 12px;
  padding: 0;
  position: relative;
  width: 100px;
  min-width: 100px;
  height: 100px;
  background-image: url("./assets/img/score.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.pa-score {
  font-size: 32px;
  font-weight: 800;
  position: absolute;
  left: 15px;
  bottom: 20px;
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
